import "@fontsource/poppins";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import { Suspense } from "react";
import { Toaster } from "react-hot-toast";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer as DefaultToastContainer } from "react-toastify";
import "react-toastify/ReactToastify.css";
import "./App.scss";
import Main from "./Main";
import PageLoader from "./app/dashboard/Components/Loader/Loader";
import { AppAlert } from "./app/dashboard/Components/Modals/AppAlert";
import { ModalOps } from "./app/dashboard/Pages/Vendors/VendorApprovals/useApprovals";
import "./app/global/styles/global.css";
import Signalr from "./helpers/signalr";
import { ModalProvider } from "./utils/contexts/Modals/ModalContext";
import { OnboardingProvider } from "./utils/contexts/Onboarding/OnboardingContext";
import store from "./utils/redux/store";

const ToastContainer = (props) => (
  <DefaultToastContainer style={{ zIndex: "1900" }} {...props} />
);
function App() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Router>
        <ModalProvider>
          <OnboardingProvider>
            <Provider store={store}>
              <Signalr>
                <Main />
              </Signalr>
              <ToastContainer />
              <AppAlert />
              <ModalOps />
            </Provider>
          </OnboardingProvider>
        </ModalProvider>
      </Router>
      <Toaster />
    </Suspense>
  );
}

export default App;
